import styled from 'styled-components'

const Style = {
	Wrapper: styled.main`
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	`,
	ContentDiv: styled.div`
		width: fit-content;
		height: fit-content;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 80px;
		background-color: ${({theme}) => theme.color.white};
		border-radius: 20px;
		padding: 96px 64px;

		& > h2 {
			${({theme}) => theme.font.large_bold}
		}
	`,
	FormDiv: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 32px;
		width: 432px;
		background-color: ${({theme}) => theme.color.white};
	`,
	BtnDiv: styled.div`
		display: flex;
		flex-direction: column;
		align-items: end;
		gap: 12px;
	`,
	Guide: styled.p`
		${({theme}) => theme.font.small};
		color: ${({theme}) => theme.color.grey3};
		margin-top: 12px;
	`,
	PasswordGuide: styled.p`
		${({theme}) => theme.font.small};
		color: ${({theme}) => theme.color.grey3};
		font-size: 12px;
		margin: 0;
		line-height: 1;
	`,
	PasswordContainer: styled.div`
		display: flex;
		flex-direction: column;
		gap: 0;
	`,
}

export default Style
